import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("tg_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("tg_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("tg_user", JSON.stringify(r.data));
      })
      .catch(() => {
        localStorage.removeItem("tg_token");
        localStorage.removeItem("tg_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const persist = (token, u) => {
    localStorage.setItem("tg_token", token);
    localStorage.setItem("tg_user", JSON.stringify(u));
    setUser(u);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.scope_company_id) {
      localStorage.setItem("tg_company_id", data.scope_company_id);
    }
    persist(data.access_token, data.user);
  };

  const adoptSession = (token, u) => persist(token, u);

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    if (data.scope_company_id) {
      // Land the user straight into the company that invited them.
      localStorage.setItem("tg_company_id", data.scope_company_id);
    }
    persist(data.access_token, data.user);
  };

  const logout = () => {
    localStorage.removeItem("tg_token");
    localStorage.removeItem("tg_user");
    localStorage.removeItem("tg_company_id");
    setUser(null);
  };

  const setRole = async (role) => {
    const { data } = await api.post("/auth/role", { role });
    setUser(data);
    localStorage.setItem("tg_user", JSON.stringify(data));
  };

  const updateMe = async (patch) => {
    const { data } = await api.patch("/users/me", patch);
    setUser(data);
    localStorage.setItem("tg_user", JSON.stringify(data));
    return data;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, setRole, updateMe, adoptSession }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
